import { render, staticRenderFns } from "./ButtonBill.vue?vue&type=template&id=4b00a9da&scoped=true&"
import script from "./ButtonBill.vue?vue&type=script&lang=js&"
export * from "./ButtonBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b00a9da",
  null
  
)

export default component.exports